import _ from 'lodash';
import fs from 'fs-extra';
import { reader } from './ndjson';
import stringify from 'json-stringify-safe';

export class JsonLogDB {

  constructor( opts={} ) {
    _.assign( this, opts );
    if ( ! this.file ) throw new Error( `JsonLogDB requires file` );
  }

  get writable() {
    if ( this._writable ) return this._writable;
    return this._writable = fs.createWriteStream( this.file, {
      flags     : 'a',
      encoding  : 'utf8',
    } );
    // return this._writable = writer( this.file );
  }

  async read( fn, opts={} ) {
    const exists = await fs.exists( this.file );
    if ( ! exists ) return;
    const res = [];
    if ( ! fn ) fn = Array.prototype.push.bind( res );
    await reader( this.file, fn, opts );
    if ( res.length ) return res;
    return;
  }

  write( data ) {
    // Re-order object so that the time property is at the front, to
    // make it easier to re-integrate logs from different systems by
    // just sotring them..
    const { time, ...rest } = data;
    data = { time, ...rest };
    this.writable.write( stringify( data ) + '\n' );
  }

}
